export const environment = {
  production: false,
  apiURLBackoffice: 'https://apibackexperienciaspre.estrellagalicia.es',
  apiURLApp: 'https://apiappexperienciaspre.estrellagalicia.es',
  msalConfig: {
    auth: {
      clientId: '8f79a891-4fd2-4106-b410-62ca8e13c8a6',
      authority: 'https://login.microsoftonline.com/4c49bed7-85da-470c-afc3-7735b371a343',
    },
  },
  apiConfig: {
    scopes: ['user.read'],
    uri: 'https://graph.microsoft.com/v1.0/me',
  },
};
